const url = '/timeZones';
const Provider = 'TimeZones';
const dbModel = 'TimeZones';

export { url, Provider, dbModel };
